import api from '../service/solicitarBaixaMei.service';
import * as types from './solicitarBaixaMei.actionTypes';
import formActions from '@common/store/form/form.actions';
import { takeEvery, call, put, select } from 'redux-saga/effects';
import solicitarBaixaMeiActions from './solicitarBaixaMei.actions';
import solicitarBaixaMeiSelector from './solicitarBaixaMei.selectors';

export default workSaga;

function* workSaga() {
  yield takeEvery(types.PESQUISAR_SOLICITAR_BAIXA_MEI, pesquisarSolicitarBaixaMei);
  yield takeEvery(types.SOLICITAR_BAIXA_MEI_SELECIONAR, selecionarBaixaMei);
  yield takeEvery(types.SOLICITAR_BAIXA_MEI_CONFIRMAR_SENHA, confirmarSenhaSolicitarBaixaMei);
  yield takeEvery(types.SOLICITAR_BAIXA_MEI_PROCESSAR, processarSolicitarBaixaMei);
}

function* pesquisarSolicitarBaixaMei(action) {
  const { payload } = action;
  const state = yield select(solicitarBaixaMeiSelector.solicitarBaixaMei);

  try {
    if (state?.tokenRecaptcha != '' && state?.tokenRecaptcha != undefined) {
      var result = yield call(api.pesquisaSolicitarBaixaMei, payload, {
        headers: { tokenRecaptcha: state?.tokenRecaptcha },
      });

      if (result.data.length > 1) {
        yield put(
          solicitarBaixaMeiActions.setSolicitarBaixaMei({
            GridSolicitarBaixaMeiPesquisa: result.data.Grid,
            CpfCnpjSolicitante: payload.CpfCnpjSolicitante,
            CpfMei: payload.CpfMei,
            FormaGerarSenha: result.data.FormaGerarSenha,
          })
        );
        yield put(formActions.gridReload());
      } else {
        const documento = result.data.Grid[0];

        yield put(
          solicitarBaixaMeiActions.setSolicitarBaixaMei({
            SolicitarBaixaMeiDados: { ...documento, CpfCnpjSolicitante: payload.CpfCnpjSolicitante },
            GridSolicitarBaixaMeiPesquisa: [],
            SolicitarBaixaMeiModalToggle: true,
            FormaGerarSenha: result.data.FormaGerarSenha,
            CpfMei: payload.CpfMei,
          })
        );
      }
    } else {
      yield resetRecaptcha();
      _alert.warning('É necessário validar o ReCaptcha.');
    }
  } catch {
    yield resetRecaptcha();
    yield put(
      solicitarBaixaMeiActions.setSolicitarBaixaMei({
        ...getEmptyState(),
      })
    );
    yield put(formActions.redirect('redeSIM.solicitarBaixaMei'));
  }
}

function* selecionarBaixaMei(action) {
  const { payload } = action;
  const state = yield select(solicitarBaixaMeiSelector.solicitarBaixaMei);

  const dto = {
    Ccm: payload.Ccm,
    CpfCnpjSolicitante: state.CpfCnpjSolicitante ?? state.SolicitarBaixaMeiDados?.CpfCnpjSolicitante,
    CpfMei: state.CpfMei,
  };

  try {
    var result = yield call(api.solicitarBaixaMei, dto);
    yield put(
      solicitarBaixaMeiActions.setSolicitarBaixaMei({
        SolicitarBaixaMeiDados: { ...result.data, CpfCnpjSolicitante: state.SolicitarBaixaMeiDados.CpfCnpjSolicitante },
        CnpjEmpresa: state.CnpjEmpresa,
        ShowBaixaMeiDadosModal: false,
        SolicitarBaixaMeiModalToggle: true,
      })
    );
  } catch (e) {
    yield resetRecaptcha();
    yield put(
      solicitarBaixaMeiActions.setSolicitarBaixaMei({
        ...getEmptyState(),
      })
    );
    yield put(formActions.redirect('redeSIM.solicitarBaixaMei'));
  }
}

function* confirmarSenhaSolicitarBaixaMei(action) {
  const { payload } = action;
  const state = yield select(solicitarBaixaMeiSelector.solicitarBaixaMei);

  const dto = {
    Ccm: state.SolicitarBaixaMeiDados.Ccm,
    CpfCnpjSolicitante: state.CpfCnpjSolicitante ?? state.SolicitarBaixaMeiDados?.CpfCnpjSolicitante,
    CpfMei: state.CpfMei,
    Senha: payload.Senha,
  };

  try {
    var result = yield call(api.confirmarSenhaSolicitarBaixaMei, dto);
    yield put(
      solicitarBaixaMeiActions.setSolicitarBaixaMei({
        ShowBaixaMeiDadosModal: true,
        SolicitarBaixaMeiHeader: result.data.Header,
        SolicitarBaixaMeiEndereco: result.data.Endereco,
        SolicitarBaixaMeiConteudo: result.data.Conteudo,
      })
    );
  } catch {
    yield resetRecaptcha();
    yield put(
      solicitarBaixaMeiActions.setSolicitarBaixaMei({
        ...getEmptyState(),
      })
    );
    yield put(formActions.redirect('redeSIM.solicitarBaixaMei'));
  }
}

function* processarSolicitarBaixaMei(action) {
  const { payload } = action;
  const state = yield select(solicitarBaixaMeiSelector.solicitarBaixaMei);

  const dto = {
    Ccm: state.SolicitarBaixaMeiDados.Ccm,
    CnpjEmpresa: state.CnpjEmpresa ?? state.SolicitarBaixaMeiDados.CnpjEmpresa,
    CpfCnpjSolicitante: state.CpfCnpjSolicitante ?? state.SolicitarBaixaMeiDados.CpfCnpjSolicitante,
    CpfMei: state.CpfMei,
    Email: payload.Email,
    MotivoBaixa: payload.MotivoBaixa,
    DataTerminoAtividade: payload.DataTerminoAtividade,
  };

  try {
    yield call(api.processarSolicitarBaixaMei, dto);
    yield put(
      solicitarBaixaMeiActions.setSolicitarBaixaMei({
        ...getEmptyState(),
      })
    );
    _alert.success('Concluído com sucesso!');
    yield put(formActions.redirect('redeSIM.solicitarBaixaMei'));
  } catch {
    yield put(
      solicitarBaixaMeiActions.setSolicitarBaixaMei({
        ...getEmptyState(),
      })
    );
    yield put(formActions.redirect('redeSIM.solicitarBaixaMei'));
  }
}

function* resetRecaptcha() {
  const state = yield select(solicitarBaixaMeiSelector.solicitarBaixaMei);
  if (state?.recaptchaResetRef) state.recaptchaResetRef.call();
}

function getEmptyState() {
  return {
    SolicitarBaixaMeiDados: [],
    GridSolicitarBaixaMeiPesquisa: [],
    SolicitarBaixaMeiModalToggle: false,
    SolicitarBaixaMeiHeader: undefined,
    SolicitarBaixaMeiEndereco: undefined,
    SolicitarBaixaMeiConteudo: undefined,
  };
}
